module.exports = __webpack_public_path__ + "img/car-poupa.ef0bba12.svg";